import Button from "../ds/Button";

/*
  The top of Discover's Mint spaces tab, from Figma B1.2: copy beside a wall of
  brand tiles, three columns of them on tablets and none on phones.
*/
const TILE_OPACITIES = [0.28, 0.12, 0.28, 0.12, 0.28, 1, 0.55, 0.55, 0.12, 0.55, 0.28, 0.28];

const SpacesHero = ({ onCreate, t }) => (
  <section className="relative flex min-h-[223px] overflow-hidden rounded-radius-xl border border-separator-default bg-bg-raised p-space-24 min-[760px]:min-h-[260px] min-[760px]:items-center min-[760px]:justify-between min-[760px]:gap-space-24 min-[760px]:px-space-40 min-[760px]:py-[30px]">
    <div className="flex min-w-0 max-w-[520px] flex-1 flex-col items-start gap-[10px]">
      <h1 className="text-large-title text-label-primary">{t("home.spacesHeroTitle")}</h1>
      <p className="text-body text-label-secondary">{t("home.spacesHeroBody")}</p>
      <Button size="m" onClick={onCreate}>
        {t("home.createSpace")}
      </Button>
    </div>
    <div
      aria-hidden="true"
      className="relative hidden shrink-0 grid-cols-[repeat(3,56px)] gap-space-16 min-[760px]:grid min-[1200px]:grid-cols-[repeat(4,56px)]"
    >
      <span className="absolute -inset-[60px] bg-[radial-gradient(closest-side,var(--color-accent-default),transparent)] opacity-[0.14]" />
      {TILE_OPACITIES.map((opacity, index) => (
        <span
          key={index}
          style={{ opacity }}
          className={`relative size-14 rounded-[16px] bg-accent-default ${index % 4 === 0 ? "hidden min-[1200px]:block" : ""}`}
        />
      ))}
    </div>
  </section>
);

export default SpacesHero;
